class FirePixelService {
    // eslint-disable-next-line class-methods-use-this
    loadImage(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.src = url;
        });
    }

    firePixels(arrayOfPixels) {
        return Promise.all(arrayOfPixels.map(this.loadImage));
    }
}
export default new FirePixelService();
